(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsw-bricks-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-bricks-planner')) {
  customElements.define('bsw-bricks-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} salt bricks (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-home-header"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get("bsw-home-navigation"))return;customElements.define("bsw-home-navigation",class extends HTMLElement{connectedCallback(){this.controller=new AbortController;const{signal}=this.controller,t=this.querySelector(".menu-toggle"),e=this.querySelector("#mobile-menu"),s=this.querySelector("[data-search-toggle]"),o=this.querySelector("#bsw-home-search"),i=t?.querySelector(".icon-hamburger"),n=t?.querySelector(".icon-close");let l=window.pageYOffset||0,c=!1;window.addEventListener("scroll",()=>{c||(window.requestAnimationFrame(()=>{const s=window.pageYOffset||0;e&&!e.hidden?(this.classList.remove("header-hidden"),l=s,c=!1):(s<=10?this.classList.remove("header-hidden","header-sticky"):s>l&&s>100?(this.classList.add("header-hidden"),this.classList.remove("header-sticky")):s<l&&(this.classList.remove("header-hidden"),this.classList.add("header-sticky")),l=s<=0?0:s,c=!1)}),c=!0)},{signal,passive:!0});const a=this.querySelectorAll(".announcement-slide"),r=1e3*parseInt(this.dataset.autoplay,10);if(a.length>1&&r>0){let t=0;const e=setInterval(()=>{a[t].classList.remove("is-active"),t=(t+1)%a.length,a[t].classList.add("is-active")},r);signal.addEventListener("abort",()=>clearInterval(e))}const d=()=>{e&&t&&(e.hidden=!0,e.classList.remove("open"),t.setAttribute("aria-expanded","false"),i&&(i.style.display="block"),n&&(n.style.display="none"))};t&&e&&(t.addEventListener("click",()=>{const s="true"!==t.getAttribute("aria-expanded");e.hidden=!s,e.classList.toggle("open",s),t.setAttribute("aria-expanded",String(s)),i&&(i.style.display=s?"none":"block"),n&&(n.style.display=s?"block":"none"),s&&(this.classList.remove("header-hidden"),this.classList.add("header-sticky"))},{signal}),e.addEventListener("click",t=>{t.target.closest("a")&&d()},{signal})),this.querySelectorAll(".mobile-dropdown-toggle").forEach(t=>{t.addEventListener("click",e=>{e.stopPropagation();const s="true"===t.getAttribute("aria-expanded"),o=t.closest(".mobile-nav-item")?.querySelector(".mobile-submenu");o&&(o.hidden=s,t.setAttribute("aria-expanded",String(!s)),t.classList.toggle("is-open",!s))},{signal})}),s&&o&&s.addEventListener("click",()=>{o.hidden=!o.hidden,s.setAttribute("aria-expanded",String(!o.hidden)),o.hidden||o.querySelector('input[type="search"]')?.focus()},{signal}),this.addEventListener("keydown",c=>{if("Escape"===c.key)if(o&&!o.hidden)o.hidden=!0,s&&(s.setAttribute("aria-expanded","false"),s.focus());else if(e&&!e.hidden)d(),t&&t.focus()},{signal})}disconnectedCallback(){this.controller?.abort()}})})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-home-planner"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get("bsw-home-planner"))return;customElements.define("bsw-home-planner",class extends HTMLElement{connectedCallback(){this.controller=new AbortController;const{signal}=this.controller,t=this.querySelector("[data-bsw-calc-form]");if(!t)return;const e=this.querySelector("[data-bsw-wall-width]"),n=this.querySelector("[data-bsw-wall-height]"),r=this.querySelector("[data-bsw-allowance]"),a=this.querySelector("[data-bsw-calc-error]"),s=this.querySelector("[data-bsw-area-output]"),o=this.querySelector("[data-bsw-base-output]"),u=this.querySelector("[data-bsw-total-output]");let c=!1;const i=()=>{c=!1;const t=e.valueAsNumber,i=n.valueAsNumber,l=Number(r.value),d=Number.isFinite(t)&&Number.isFinite(i)&&t>=.01&&i>=.01&&t<=1e3&&i<=1e3&&[0,5,10,15].includes(l);if(a.textContent=d?"":this.dataset.error,!d)return s.textContent="—",o.textContent="—",void(u.textContent="—");const m=t*i,h=Math.ceil(Number((4.5*m).toFixed(8))),f=Math.ceil(Number((4.5*m*(1+l/100)).toFixed(8)));s.textContent=m.toFixed(1).replace(".0",""),o.textContent=h.toLocaleString(),u.textContent=f.toLocaleString()},l=()=>{c||(c=!0,window.requestAnimationFrame(i))};t.addEventListener("input",l,{signal,passive:!0}),t.addEventListener("change",l,{signal,passive:!0}),t.addEventListener("submit",t=>{t.preventDefault(),i()},{signal})}disconnectedCallback(){this.controller?.abort()}})})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-tiles-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-tiles-planner')) {
  customElements.define('bsw-tiles-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} salt tiles (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-white-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-white-guide-visibility')) {
  customElements.define('bsw-white-guide-visibility', class extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('.bsw-white-content');
      const fallback = this.querySelector('.bsw-white-return');
      this.syncVisibility = () => {
        const params = new URLSearchParams(window.location.search);
        const filtered = [...params].some(([key, value]) => key.startsWith('filter.') && value !== '');
        const hidden = !content || filtered || Number(params.get('page') || 1) > 1;
        if (content) content.hidden = hidden;
        fallback.hidden = !hidden;
      };
      this.observer = new MutationObserver(this.syncVisibility);
      const grid = document.getElementById('ProductGridContainer');
      if (grid) this.observer.observe(grid, { childList: true });
      window.addEventListener('popstate', this.syncVisibility);
      this.syncVisibility();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('popstate', this.syncVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-white-tiles-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-white-planner')) {
  customElements.define('bsw-white-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} white salt tiles (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-calc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-cost-estimator')) {
  customElements.define('bsw-cost-estimator', class extends HTMLElement {
    static estimate(width, height, allowance, tubes) {
      if (![width, height, allowance, tubes].every(Number.isFinite) || width < 0.01 || height < 0.01 || width > 1000 || height > 1000 || allowance < 0 || allowance > 100 || !Number.isInteger(tubes) || tubes < 0 || tubes > 10000) return null;
      const area = width * height;
      const base = Math.ceil(Number((area * 4.5).toFixed(8)));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));
      return { area, base, pieces, tubes };
    }
    static costs(pieces, tubes, unitPrice, adhesivePrice) {
      const validPrice = price => Number.isInteger(price) && price >= 0;
      const saltCost = validPrice(unitPrice) ? pieces * unitPrice : null;
      const adhesiveCost = tubes === 0 ? 0 : validPrice(adhesivePrice) ? tubes * adhesivePrice : null;
      const total = saltCost !== null && adhesiveCost !== null ? saltCost + adhesiveCost : null;
      return { salt_cost: saltCost, adhesive_cost: adhesiveCost, total };
    }
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const select = this.querySelector('[data-product]');
      const fields = ['width', 'height', 'waste', 'tubes'].map(key => this.querySelector(`[data-${key}]`));
      const form = this.querySelector('form');
      const submit = this.querySelector('[data-submit]');
      const body = this.querySelector('[data-quote-body]');
      const message = this.querySelector('[data-message]');
      const priceLabel = this.querySelector('[data-price-label]');
      const outputs = Object.fromEntries(Array.from(this.querySelectorAll('[data-output]'), node => [node.dataset.output, node]));
      const money = cents => {
        if (cents === null) return '—';
        try { return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
        catch { return `${(cents / 100).toFixed(2)} ${this.dataset.currency}`; }
      };
      const number = value => new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 4 }).format(value);
      const priceFrom = data => data && data.available === 'true' && data.price !== '' && data.price !== undefined ? Number(data.price) : null;
      const calculate = () => {
        const option = select.selectedOptions[0];
        const unitPrice = priceFrom(option?.dataset);
        const adhesivePrice = priceFrom({ price: this.dataset.adhesivePrice, available: this.dataset.adhesiveAvailable });
        
        // Dynamic label based on selection (Tile vs Brick)
        const itemType = option?.dataset.type || 'Tile';
        if (priceLabel) {
          priceLabel.textContent = `Each ${itemType} Price`;
        }

        outputs.unit_price.textContent = money(unitPrice);
        const estimate = this.constructor.estimate(...fields.map(field => field.valueAsNumber));
        const valid = Boolean(estimate && option && fields.every(field => field.validity.valid));
        if (submit) submit.disabled = !valid;
        if (!valid) {
          Object.entries(outputs).forEach(([key, node]) => { if (key !== 'unit_price') node.textContent = '—'; });
          message.textContent = option ? this.dataset.invalid : this.dataset.unavailable;
          if (body) body.value = '';
          return false;
        }
        const costs = this.constructor.costs(estimate.pieces, estimate.tubes, unitPrice, adhesivePrice);
        for (const [key, value] of Object.entries(estimate)) outputs[key].textContent = number(value);
        for (const [key, value] of Object.entries(costs)) outputs[key].textContent = money(value);
        message.textContent = costs.total === null ? this.dataset.unavailable : '';
        if (body) {
          const details = [this.dataset.quoteTitle, option.textContent, `Variant: ${option.value}`];
          for (const field of fields) details.push(`${this.querySelector(`label[for="${field.id}"]`).textContent}: ${field.value}`);
          for (const label of this.querySelectorAll('[data-result-label]')) details.push(`${label.textContent}: ${outputs[label.dataset.resultLabel].textContent}`);
          details.push(this.querySelector('[data-exclusions]').textContent);
          body.value = details.join('\n');
        }
        return true;
      };
      for (const event of ['input', 'change']) this.addEventListener(event, calculate, { signal });
      if (form) form.addEventListener('submit', event => {
        if (!calculate()) {
          event.preventDefault();
          const invalid = fields.find(field => !field.validity.valid);
          if (invalid) { invalid.focus(); invalid.reportValidity(); }
        }
      }, { signal });
      calculate();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
